import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import { getHasSpliceAiData } from "../../../../state/selectors/spliceAi/selectors";

function SpliceAiCard({ card }) {
  const hasData = useSelector(getHasSpliceAiData);
  return (
    <CardWrapper {...card} isDisabled={!hasData}>
      {hasData ? (
        <div className="tw-text-xs">Top 4 events in proximal splice site</div>
      ) : null}
    </CardWrapper>
  );
}

SpliceAiCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
};

export default SpliceAiCard;
